require('./style.scss')
class TagInputDirective
  @$inject: ["$timeout", '$http', 'config']
  constructor: ($timeout, $http, config)->
    url = "#{config.api.url}/tags"   
    class TagInput
      restrict: 'E'
      template: require("./tag-input.pug")
      # controller: TagInputCtrl
      # controllerAs: '$ctrl'
      link: ($scope, element, attrs, $ctrl)->
        parentScope = $scope.$parent
        parentScope.child = $scope
        $scope.inputText = ""
        $scope.focusInput = false
        $scope.tagSource = []
        $scope.autocompleteTagList = [];
        $scope.inputTagList = []
        $scope.placeholder = attrs.placeholder

        $http.get("#{url}/all")
          .then (result)->
            $scope.tagSource = result.data
            $scope.autocompleteTagList = $scope.tagSource

        $scope.inputFocus = (e)->
          inputFieldRect = element.find('.input-tag-list')[0].getBoundingClientRect()
          $scope.focusInput = !$scope.focusInput
          autocompletePanel = element.find('.tag-autocomplete-container')
          autocompletePanel.css('width', inputFieldRect.width );

        $scope.leaveInputFocus = (e)->
          $scope.focusInput = !$scope.focusInput
        
        $scope.selectTag = (tag)->
          if !$scope.inputTagList.includes(tag)
            $scope.inputTagList.push(tag)
            $scope.$parent.$ctrl.inputTagList.push tag;
            $scope.inputText = ""

        $scope.inputTextConfirm =($event)->
          if $event.which is 13 && $scope.inputText?.length > 0
            if tagExist($scope.inputText, $scope.inputTagList)
              $scope.inputText = ""
            else if tagExist($scope.inputText, $scope.tagSource)
              for index, element in $scope.tagSource
                if element.text is $scope.inputText
                  $scope.inputTagList.push element
                  $scope.$parent.$ctrl.inputTagList.push element
                  $scope.inputText = ""
                break
              
            else
              newTag = {text: $scope.inputText}
              $scope.inputTagList.push newTag
              $scope.$parent.$ctrl.inputTagList.push newTag
              $scope.inputText = ""

        $scope.typing = ($event)->
          reg = ///^#{$scope.inputText}///i
          $scope.autocompleteTagList = $scope.tagSource.filter (tag)->
            reg.test tag.text
          
        
        $scope.untag = (tag)->
          for item, index in $scope.$parent.$ctrl.inputTagList
            if tag is item
              $scope.$parent.$ctrl.inputTagList.splice(index, 1)
              break
          $scope.inputTagList = $scope.$parent.$ctrl.inputTagList

        tagExist = (tagName, tagList)->
          return tagList.some (tag)->
            tag.text is tagName
        return @ 


        # if $scope.autocomplete
        #   $scope.autocompleteFocus = (event, ui) ->
        #     $(element).find('input').val( ui.item.value )
        #     return false

        #   $scope.autocompleteSelect = (event, ui) ->
        #     $scope.$apply "tagText='#{ui.item.value}'"
        #     $scope.$apply 'addTag()'
        #     return false

        #   $(element).find('input').autocomplete
        #     minLength: 0
        #     source: (request, response) ->
        #       response (item for item in $scope.autocomplete when item.toLowerCase().indexOf(request.term.toLowerCase()) != -1)
        #     focus: (event, ui) => $scope.autocompleteFocus(event, ui)
        #     select: (event, ui) => $scope.autocompleteSelect(event, ui)
    return new TagInput()

# class TagInputCtrl
#   @$injector = ['$scope']
#   constructor: ($scope)->
#     $scope.searchTag = false
#     $scope.tagList = [{_id:"1", name:"11" },{_id:"2", name:"22" },{_id:"3", name:"33" }]
#     $scope.inputTagList = [{_id:"1", name:"11" }]
#     # $scope.placeholder = attrs.placeholder
#     $scope.test = ()->
#       console.log $scope.inputTagList




module.exports = TagInputDirective


// WEBPACK FOOTER //
// ./src/component/device/bulk-action/tag-input/index.coffee